// Copyright 2017 Sorama B.V.

import { bindable, bindingMode, customAttribute, DOM, inject } from "aurelia-framework";

@customAttribute("variable", bindingMode.twoWay)
@inject(DOM.Element)
export class Variable {
    public element: HTMLElement;
    private context: { [key: string]: unknown };

    @bindable
    private names: string[];

    @bindable
    private values: unknown[];

    constructor(element: HTMLElement) {
        this.element = element;
    }

    public bind(context: { [key: string]: unknown }) {
        if (this.names.length !== this.values.length) {
            throw new Error("Number of values does not match the number of names");
        }

        this.context = context;
        this.valuesChanged();
    }

    public valuesChanged(): void {
        if (this.names.length !== this.values.length) {
            return;
        }

        for (let i = 0; i < this.names.length; i++) {
            this.context[this.names[i]] = this.values[i];
        }
    }
}
